/**
 * SIR Form Fields.
 * @format
 */
import {
  countryList,
  countryParentItemsList,
} from '../../form-components/lists/country-list';
import { stateList } from '../../form-components/lists/state-list';

const learnMoreList = [
  {
    name: 'Cryoablation (CryoCare Touch and cryoprobes)',
    value: 'Cryoablation (CryoCare Touch and cryoprobes)',
  },
  {
    name: 'Embolics (Embozene and Oncozene)',
    value: 'Embolics (Embozene and Oncozene)',
  },
  { name: 'ARTIS icono Ceiling', value: 'ARTIS icono Ceiling' },
  { name: 'Computed Tomography', value: 'Computed Tomography' },
  { name: 'CT-guided interventions', value: 'CT-guided interventions' },
  { name: 'Image-guided Therapy', value: 'Image-guided Therapy' },
  { name: 'Ultrasound', value: 'Ultrasound' },
  {
    name: 'Medical Affairs (Medical Information Request)',
    value: 'Medical Affairs (Medical Information Request)',
  },
  {
    name: 'Continued Medical Education',
    value: 'Continued Medical Education',
  },
];

export const sirFormFields = [
  {
    fieldTitle: 'Please provide your contact information:',
    fieldName: 'tri-contact-info',
    type: 'markup',
    id: 'markup1',
  },
  {
    fieldTitle: 'First Name',
    fieldName: 'FirstName',
    id: 'fname',
    type: 'text',
    placeholderText: 'Your first name here',
    errorMessage: 'First Name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Last Name',
    fieldName: 'LastName',
    id: 'lname',
    type: 'text',
    placeholderText: 'Your last name here',
    errorMessage: 'Last Name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Organization',
    fieldName: 'Organization',
    id: 'organization',
    type: 'text',
    placeholderText: "Your organization's name",
    errorMessage: 'Organization field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Email address',
    fieldName: 'Email',
    id: 'email',
    type: 'email',
    placeholderText: 'name@website.com',
    errorMessage: 'Invalid email.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },

  {
    fieldTitle: 'Country',
    fieldName: 'Country',
    id: 'country-select',
    type: 'select',
    placeholderText: 'Select a country',
    errorMessage: 'Country field required.',
    required: true,
    list: countryList,
    useNameAsLookupValue: true,
    parentItems: countryParentItemsList,
    dependencyId: 'state-select',
  },

  {
    fieldTitle: 'City',
    fieldName: 'City',
    id: 'city',
    type: 'text',
    placeholderText: "Your Company's city",
    errorMessage: 'City field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'State or province',
    fieldName: 'State',
    id: 'state-select',
    type: 'select',
    placeholderText: 'Select a state or province',
    errorMessage: 'State or province field required.',
    required: true,
    list: stateList,
    useNameAsLookupValue: true,
    dependentField: true,
  },
  {
    fieldTitle: 'Zip Code',
    fieldName: 'PostalCode',
    id: 'postalcode',
    type: 'text',
    placeholderText: "Your Company's postal code",
    errorMessage: 'Postal Code field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
    dependentField: true,
  },
  {
    fieldTitle: 'Business Phone',
    fieldName: 'Phone',
    id: 'phone',
    type: 'text',
    placeholderText: "Your Business's phone number",
    errorMessage: 'Phone number field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },

  {
    fieldTitle:
      'Choose the area you would like to learn more about with an exclusive demo at SIR 2023',
    fieldName: 'Learn More',
    id: 'learn-more',
    type: 'select',
    placeholderText: 'Select an area of interest',
    errorMessage: 'Learn More field required.',
    required: true,
    list: learnMoreList,
    useNameAsLookupValue: true,
  },
];
